// extracted by mini-css-extract-plugin
export var container = "_ex-0";
export var content = "_ex-3";
export var customerTitle = "_ex-4";
export var empty = "_ex-5";
export var gray = "_ex-6";
export var header = "_ex-7";
export var info = "_ex-8";
export var loading = "_ex-2";
export var loadingCard = "_ex-9";
export var oneLine = "_ex-a";
export var personName = "_ex-e";
export var pillContainer = "_ex-b";
export var selected = "_ex-1";
export var text = "_ex-c";
export var twoLines = "_ex-d";
export var unread = "_ex-f";
export var unreadIndicator = "_ex-g";